<template>
  <v-checkbox
    :class="compClass +
      ((getForAccessibility) ? ' for-accessibility-app ' : '')"
    :label="translateLabel"
    :indeterminate="indeterminate"
    :value="checkValue"
    v-model="elValue"
    :disabled="disabled"
    :readonly="readonly"
    v-validate="validateRules"
    :data-vv-name="validateName"
    :error-messages="errorMessages"
    
    :data-vv-validate-on="required ? 'input' : 'change'"
    hide-details="auto"
    @change="change"
    @click="click"
  >
    <template slot="label">
      <template v-if="$slots.label">
        <slot name="label"></slot>
      </template>
      <template v-else>{{ translateLabel }}</template>
      <el-tooltip v-if="tooltip" :indexKey="tooltipIndexKey" :tooltip="tooltip" checkbox/>
      <div class="ml-4" v-if="afterLabel">{{ afterLabel }}</div>
    </template>
  </v-checkbox>
</template>

<script>
import errorNotifications from '@/mixins/errorNotifications'
import { mapGetters } from 'vuex'
export default {
  name: 'ElCheckbox',
  mixins: [errorNotifications],
  props: {
    classP: String,
    label: String,
    checkValue: [Object, Boolean, String, Number],
    value: [Object, Boolean, String, Array, Number],
    tooltip: String,
    disabled: Boolean,
    readonly: Boolean,
    required: Boolean,
    silent: { type: Boolean, default: false },
    need: Boolean,
    notTranslated: Boolean,
    inline: { type: Boolean, default: false },
    afterLabel: { type: String, default: null },
    validateKey: String,
    indeterminate: Boolean,
    tooltipIndexKey: String,
  },
  inject: {
    $validator: '$validator',
  },
  computed: {
    ...mapGetters(['getForAccessibility']),
    elValue: {
      get() {
        return this.value
      },
      set(elValue) {
        this.$emit('input', elValue)
      },
    },

    translateLabel() {
      return this.notTranslated ? this.label : this.$t(this.label)
    },

    requiredClass() {
      return (this.required || this.need) && !this.readonly && !this.silent
        ? 'required-input'
        : ''
    },

    compClass() {
      return `${this.classP} ${this.requiredClass} ${
        this.inline ? 'inline' : ''
      }`
    },

    validateName() {
      return (
        this.validateKey ??
        (this.label && this.label.length > 0 ? this.label : 'checkbox')
      )
    },

    validateMessages() {
      return {
        field: this.notificationText('000006') || this.$t('Laukas privalomas'),
      }
    },

    validateValue() {
      return { value: null }
    },

    validateRules() {
      let rule = ''
      if (this.required) {
        rule = this.checkValue ? 'required' : 'max:4'
      }
      return rule
    },

    errorMessages() {
      const messages = this.errors.collect(this.validateName)
      if (messages.length > 0) {
        const key = Object.keys(this.validateMessages).find((item) =>
          messages[0].includes(item)
        )
        return this.validateMessages[key]
      } else {
        return ''
      }
    },
  },
  methods: {
    change() {
      this.$emit('change')
    },
    click() {
      this.$emit('click')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/styles/elements.scss';
.inline {
  display: inline-block;
}
</style>
